import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-left-circle",
  "use": "arrow-left-circle-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"arrow-left-circle\"><path d=\"M217.5 120.5L101.1 236.9c-9.1 9.1-9.1 23.8 0 32.9l116.4 116.4c9.1 9.1 23.8 9.1 32.9 0s9.1-23.8 0-32.9l-76.7-76.7H397c12.9 0 23.3-10.4 23.3-23.3S409.9 230 397 230H173.8l76.7-76.7c4.5-4.5 6.8-10.5 6.8-16.5s-2.3-11.9-6.8-16.5c-9.2-8.9-23.9-8.9-33 .2z\" /><circle cx=\"257.3\" cy=\"253.4\" r=\"238.5\" fill=\"none\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/arrow-left-circle.svg
// module id = h9Y7
// module chunks = 1